import type { AccessToken } from '@okta/okta-auth-js';

/** Seconds before expiry when a token is treated as unusable and should be renewed. */
export const ACCESS_TOKEN_EXPIRY_SKEW_SECONDS = 30;

/**
 * Returns true when the Okta access token exists and is not expired (with skew).
 */
export function isAccessTokenUsable(
  token: AccessToken | undefined,
  nowEpochSeconds = Math.floor(Date.now() / 1000),
): boolean {
  if (!token?.accessToken) {
    return false;
  }

  const expiresAt = token.expiresAt;
  if (typeof expiresAt !== 'number') {
    return false;
  }

  return expiresAt > nowEpochSeconds + ACCESS_TOKEN_EXPIRY_SKEW_SECONDS;
}
